import { CircleAlert } from "lucide-react";

import type { EditableTableItemsV2 } from "@/apis/editable-preview/types";
import { XBRLPreview } from "@/components/final-preview/contents/xbrl/xbrl-preview";
import {
  getUnitDivisorFromExponent,
  getUnitLabelFromExponent,
} from "@/utils/ixd-editor/unit-conversion";

export const MatchedTableEmpty = ({ tableName }: { tableName: string }) => (
  <div className="flex h-full min-h-[160px] flex-col items-center justify-center gap-2.5 rounded-md border border-dashed border-line-normal bg-background-neutral-alternative">
    <div className="rounded-md bg-status-caution p-2">
      <CircleAlert className="size-5 text-static-white" />
    </div>
    <p className="label-2-medium text-label-normal text-center tracking-[0.25px]">
      매칭된 표({tableName})의
      <br />
      생성된 산출물이 없습니다.
    </p>
  </div>
);

export const MatchedTablePeriodView = ({
  tablePreview,
  period,
  isError,
}: {
  tablePreview: EditableTableItemsV2;
  period: "CURRENT" | "PRIOR";
  isError: boolean;
}) => (
  <div
    className="min-w-0 [&_[data-final-period-label]]:hidden [&_[data-final-unit-label]]:hidden"
    // unit 이 null 이면 원화 단위 선언이 없다는 뜻이라 두 속성 모두 사라진다.
    // 존재를 전제하는 reader 를 만들지 말 것.
    data-source-unit-divisor={
      tablePreview.unit == null
        ? undefined
        : getUnitDivisorFromExponent(tablePreview.unit)
    }
    data-source-unit-label={
      tablePreview.unit == null
        ? undefined
        : getUnitLabelFromExponent(tablePreview.unit)
    }
  >
    <XBRLPreview
      isError={isError}
      tablePreview={tablePreview}
      period={period}
      density="compact"
    />
  </div>
);
